// extracted by mini-css-extract-plugin
export default {"custombutton":"common_custombutton__Wypfx"};